/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormFieldProps, FormFieldState } from '@/shared/ui/form/types';

type Options = {
    isDirty: boolean;
    isTouched: boolean;
    invalid: boolean;
    isSuccessVisible?: FormFieldProps<any>['isSuccessVisible'];
    isErrorVisible?: FormFieldProps<any>['isErrorVisible'];
};

export const getFormFieldState = ({
    invalid,
    isDirty,
    isTouched,
    isErrorVisible = false,
    isSuccessVisible = false,
}: Options): FormFieldState => {
    if (invalid) {
        switch (isErrorVisible) {
            case 'onDirty': {
                return isDirty || isTouched ? 'error' : 'default';
            }
            case 'onTouched': {
                return isTouched ? 'error' : 'default';
            }
            case true: {
                return 'error';
            }
            case false: {
                return 'default';
            }
        }
    } else {
        switch (isSuccessVisible) {
            case 'onDirty': {
                return isDirty ? 'success' : 'default';
            }
            case 'onTouched': {
                return isTouched ? 'success' : 'default';
            }
            case true: {
                return 'success';
            }
            case false: {
                return 'default';
            }
        }
    }
};
